import { render, staticRenderFns } from "./settingCompanySalarySettings.vue?vue&type=template&id=7f14aeaa&scoped=true&"
import script from "./settingCompanySalarySettings.vue?vue&type=script&lang=js&"
export * from "./settingCompanySalarySettings.vue?vue&type=script&lang=js&"
import style0 from "./settingCompanySalarySettings.vue?vue&type=style&index=0&id=7f14aeaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f14aeaa",
  null
  
)

export default component.exports